import { mapActions, mapGetters, mapMutations } from 'vuex'
import { debounce } from 'lodash'

export default {
    name: 'setting-analysis-options-filter',
    data () {
        return {
            filter: {
                keywords: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            filterKeywords: 'settingAnalysisOptions/filterKeywords'
        })
    },
    created () {
        this.setFilters()
    },
    methods: {
        ...mapActions({
            fetchList: 'settingAnalysisOptions/GET_LIST'
        }),
        ...mapMutations({
            changeFilter: 'settingAnalysisOptions/CHANGE_LIST_FILTER',
            setListLength: 'settingAnalysisOptions/SET_LIST_LENGTH',
            changeSkip: 'settingAnalysisOptions/CHANGE_SKIP'
        }),
        setFilters () {
            this.filter.keywords = this.filterKeywords
        },
        sendRequest: debounce(function () {
            this.fetchList()
        }, 500),
        changeFilterLocal (val, type) {
            this.changeFilter({
                type: type,
                value: val
            })

            this.sendRequest()

            this.setListLength(0)
            this.changeSkip(0)
        }
    }
}
